<template>
    <div class="index-wrapper">
        <span class="version">version:{{ network.version }}</span>
        <div class="logo">
            <img class="logo-image" alt="iHuacloud" src="https://huay.obs.cn-south-1.myhuaweicloud.com/p/hy.png" />
        </div>
        <div class="qrcode">
            <img class="qrcode-image" alt="qrcode" :src="qrcodeUrl" />
            <div class="qrcode-hints" style="font-size: 20px">请使用华云APP扫码绑定</div>
        </div>
        <div class="device-info">
            <div class="label">投屏ID</div>
            <div class="value">{{ deviceId }}</div>
        </div>
        <div class="footer">
            <div>
                <span style="font-size: 20px">{{ dateweek.day }} {{ dateweek.week }}</span>
                <span class="mock-block" style="padding-bottom: 7px">
                    <img class="icon" src="@/assets/visualization/calendar.svg" />
                </span>
                
            </div>
            <div>
                <span style="font-size: 20px; color: red" v-if="network.msg">{{network.msg}}</span>
            </div>
            <div>
                <span style="font-size: 20px">{{ dateweek.time }}</span>
                <span class="mock-block" style="padding-bottom: 7px">
                    <img class="icon" src="@/assets/visualization/time.svg" />
                </span>
            </div>
        </div>
    </div>
</template>
<script>
// 引用
import qrcode from "qrcode";
import { nanoid } from "nanoid";

export default {
    props: {
        dateweek: [Object],
        network: {
            type: Object
        },
        bind: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            qrcodeUrl: undefined,
            timer: undefined,
            refreshData: undefined,
        };
    },
    methods: {
        //生成二维码
        generateQrCode() {
            qrcode.toDataURL(
                this.deviceId,
                {
                    width: 667, //自定义宽度
                    margin: 1,
                    color: {
                        dark: "#020202", //自定义码的颜色
                        light: "#ffffff", //自定义背景颜色
                    },
                },
                (err, url) => {
                    if (!err) {
                        this.qrcodeUrl = url;
                    }
                }
            );
        },
    },
    computed: {
        //获取设备唯一ID
        deviceId: function () {
            let deviceId = localStorage.getItem("deviceId");
            //缓存存在时之间返回
            if (!deviceId) {
                deviceId = nanoid();
                localStorage.setItem("deviceId", deviceId);
            }
            return deviceId;
        },
    },
    created() {
        this.generateQrCode()
    },
    // 由于看板机器对：min，支持不够，使用下面方式适配
};
</script>

<style lang="less" scoped>
.index-wrapper {
    //--w: ~"min(100vw, 56.25vh)";
    display: grid;
    grid-template-rows: auto 1fr auto;

    width: var(--w);
    height: 90vh;
    margin: 0 auto;
    padding: 9vh calc(50vw - var(--w) / 2) 0;

    background: #2f2f2f;
    color: white;
    font-family: "Alibaba PuHuiTi 2.0 65 Medium", "Avenir", Helvetica, Arial,
        sans-serif;
    font-size: calc(var(--w) * 0.07);
    .logo {
        height: 22.5vh;

        img {
            width: 30%;
        }
    }

    .qrcode {
        img {
            width: 70%;
        }
    }

    .device-info {
        font-size: 0.618em;
    }

    .footer {
        height: 4vh;
        background: #D0E9FF;
        padding: 5px 20px 5px 20px;
        color: #606266;
        display: flex;
        justify-content: space-between;

        div {
            display: flex;
            align-items: center;

            .icon {
                width: 30px;
                height: auto;
                vertical-align: middle;
                margin: 0 0 0 20px;
            }
        }

    }
}

.version{
    font-size:20px;
    position: absolute;
    left: 0px;
    top: 10px;
    color:rgba(255, 255, 255, 0.6)
}


</style>


// WEBPACK FOOTER //
// src/components/HelloQrcode.vue